import { render, staticRenderFns } from "./playerCareerHighlights.vue?vue&type=template&id=05647aae&scoped=true"
import script from "./playerCareerHighlights.vue?vue&type=script&lang=js"
export * from "./playerCareerHighlights.vue?vue&type=script&lang=js"
import style0 from "./playerCareerHighlights.vue?vue&type=style&index=0&id=05647aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05647aae",
  null
  
)

export default component.exports